import {type DependencyList, useMemo as useMemoReact} from 'react';

import {useDurationVital} from './useDurationVital';

/**
 * A drop-in replacement for `useMemo`. This fn takes an additional param of
 * metricName. Whenever the memoized value is regenerated, the duration of that
 * generation process is tracked and sent to Datadog attached to the provided
 * metricName.
 *
 * @param factory
 * @param deps
 * @param metricName
 */
export function useMemo<T>(
  factory: () => T,
  deps: DependencyList,
  metricName: string
): T {
  const {record} = useDurationVital(metricName);

  return useMemoReact(() => {
    const start = performance.now();
    const valInternal = factory();
    record(start, start - performance.now());
    return valInternal;
  }, [...deps, record]);
}
